var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useQuery } from '@tanstack/react-query';
import { useDareDropApi } from 'root/src/client/v2/common/hooks/useDareDropApi';
import { rewardEndpointIds } from 'root/src/shared/rewards/constants';
export const useCreatorHasReservedProduct = (dropId, enabled = true) => {
    const { fetcher } = useDareDropApi();
    return useQuery({
        enabled,
        queryKey: [rewardEndpointIds.CREATOR_HAS_RESERVED_PRODUCT, dropId],
        queryFn: () => __awaiter(void 0, void 0, void 0, function* () {
            return fetcher({
                endpointId: rewardEndpointIds.CREATOR_HAS_RESERVED_PRODUCT,
                payload: {
                    dropId,
                },
            });
        }),
    });
};
